import { useState } from "react";
import { Loader2, Plus } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "../../lib/api";
import TitlePicker from "./TitlePicker";

const field = "w-full rounded-[var(--card-radius)] border border-[var(--border-subtle)] bg-[var(--bg-card)] px-3 py-2.5 text-sm text-[var(--text-primary)] outline-none focus:border-[var(--accent)]";
const label = "mb-1 block text-xs font-semibold uppercase tracking-wider text-[var(--text-secondary)]";

export default function EpisodeForm({ slug, onAdded }) {
  const [title, setTitle] = useState("");
  const [url, setUrl] = useState("");
  const [picked, setPicked] = useState([]);
  const [saving, setSaving] = useState(false);
  const [pickerKey, setPickerKey] = useState(0);
  const submit = async (e) => {
    e.preventDefault();
    if (!picked.length) { toast.error("Pick at least one film or show"); return; }
    setSaving(true);
    try {
      await api.post(`/podcasts/${slug}/episodes`, { title, url: url.trim(), title_ids: picked.map((p) => p.id) });
      toast.success("Episode sent for review");
      setTitle(""); setUrl(""); setPicked([]); setPickerKey((k) => k + 1); onAdded();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail) || "Couldn't add episode"); }
    finally { setSaving(false); }
  };
  return (
    <form onSubmit={submit} className="mt-4 space-y-4 rounded-[var(--card-radius)] border border-[var(--border-accent)] bg-[var(--bg-surface)] p-4" data-testid="episode-form">
      <div><label className={label}>Episode title *</label><input className={field} value={title} onChange={(e) => setTitle(e.target.value)} required maxLength={150} data-testid="episode-title-input" /></div>
      <div><label className={label}>Episode link *</label><input type="url" className={field} value={url} onChange={(e) => setUrl(e.target.value)} required placeholder="https://…" data-testid="episode-url-input" /></div>
      <div><label className={label}>Which films or shows is it about? (up to 3) *</label><TitlePicker key={pickerKey} picked={picked} onChange={setPicked} /></div>
      <button type="submit" disabled={saving} className="inline-flex items-center gap-2 rounded-[var(--card-radius)] bg-[var(--accent)] px-6 py-2.5 font-bold uppercase tracking-wide text-[var(--accent-contrast)] disabled:opacity-60" data-testid="episode-submit">
        {saving ? <Loader2 size={16} className="animate-spin" /> : <Plus size={16} />} Send for review
      </button>
    </form>
  );
}
